// Pure formatting helpers — kept stateless so they're trivial to test or reuse
// from any component or hook. Mirrors the helpers from the old monolith.

export function formatDuration(ms) {
  if (ms == null || ms < 0) ms = 0;
  const s = Math.floor(ms / 1000);
  const hh = String(Math.floor(s / 3600)).padStart(2, '0');
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

export function centsToUsd(c) {
  if (c == null) return '—';
  return '$' + (c / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function iso(ms) {
  return new Date(ms).toISOString().slice(0, 10);
}

export function toDateInput(ms) {
  const d = new Date(ms);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}
const pad = n => String(n).padStart(2, '0');

export function toLocalDateTimeInput(ms) {
  const d = new Date(ms);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fromLocalDateTimeInput(v) {
  return new Date(v).getTime();
}

// Week range with Monday as day 0. weeksAgo = 0 → this week, -1 → last week.
export function weekRangeOffset(weeksAgo = 0) {
  const now = new Date();
  const day = (now.getDay() + 6) % 7;
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - day + weeksAgo * 7);
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return { from: +start, to: +end };
}

// Inverse of weekRangeOffset — given a range, return the weeksAgo offset.
export function rangeKey(r) {
  const { from } = weekRangeOffset(0);
  return String(Math.round((r.from - from) / (7 * 86400 * 1000)));
}
